import React, { useState, useEffect } from 'react';
import { Route, Switch, Redirect } from "react-router-dom";
import { Routes } from "../routes";
import MessengerCustomerChat from 'react-messenger-customer-chat';
// pages

import Player from "./tables/Player";
import Players from "./tables/Players";
import Ranking from "./tables/Ranking";
import Home from "./tables/Home";


// documentation pages


// components

import NavBaR from "./NavBar.js";
import Preloader from "../components/Preloader";



const RouteWithLoader = ({ component: Component, ...rest }) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Route {...rest} render={props => (<> <Preloader show={loaded ? false : true} /> <Component {...props} /> </>)} />
  );
};

const RouteWithSidebar = ({ component: Component, ...rest }) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  const localStorageIsSettingsVisible = () => {
    return localStorage.getItem('settingsVisible') === 'false' ? false : true
  }

  const [showSettings, setShowSettings] = useState(localStorageIsSettingsVisible);

  const toggleSettings = () => {
    setShowSettings(!showSettings);
    localStorage.setItem('settingsVisible', !showSettings);
  }

  return (
    <Route {...rest} render={props => (
      <>
        <NavBaR />

        <main className="kmain" >
          <Component {...props} />
        </main>
      </>
    )}
    />
  );
};

export default () => (
  <>
    <MessengerCustomerChat
      pageId="1459932097657240"
      appId="987988882127246"
    />
    <Switch>
      <RouteWithSidebar exact path={Routes.Home.path} component={Home} />
      <RouteWithSidebar exact path={Routes.Ranking.path} component={Ranking} />
      <RouteWithSidebar exact path={Routes.Players.path} component={Players} />
      <RouteWithSidebar exact path={Routes.Player.path} component={Player} />
      {/* pages */}
      {/* components */}
      <Redirect to={Routes.NotFound.path} />
    </Switch>
  </>
);
